import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-3 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]

import { ref, provide } from "vue";
import MainIndex from "../components/lead/MainIndex.vue";
import UtmIndex from "../components/lead/UtmIndex.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLead',
  setup(__props) {

const TabStatus = [
  { label: "All", value: 0 },
  { label: "UTM", value: 1 },
];

const isLoading = ref(false);
provide("isLoading", isLoading);
const currTab = ref(TabStatus[1].value);

const changeTab = (tab: any) => {
  currTab.value = tab;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TabStatus, (tab, index) => {
        return _createElementVNode("li", {
          class: "nav-item",
          key: index
        }, [
          _createElementVNode("a", {
            class: _normalizeClass([
          'nav-link text-active-primary pb-1',
          { active: currTab.value === tab.value },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: ($event: any) => (!isLoading.value && changeTab(tab.value))
          }, _toDisplayString(tab.label), 11, _hoisted_2)
        ])
      }), 64))
    ]),
    (currTab.value === 0)
      ? (_openBlock(), _createBlock(MainIndex, { key: 0 }))
      : (currTab.value === 1)
        ? (_openBlock(), _createBlock(UtmIndex, { key: 1 }))
        : _createCommentVNode("", true)
  ], 64))
}
}

})